export const ProductTypeIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5667 0.666656H4.66667C4.3 0.666656 4 0.966657 4 1.33332V3.69999C4 3.83999 4.04667 3.97999 4.12667 4.09332L5.62 6.15999V14.6667C5.62 15.0333 5.92 15.3333 6.28667 15.3333H9.94667C10.3133 15.3333 10.6133 15.0333 10.6133 14.6667V6.15999L12.1067 4.09332C12.1867 3.97999 12.2333 3.83999 12.2333 3.69999V1.33332C12.2333 0.966657 11.9333 0.666656 11.5667 0.666656ZM8.78667 8.73332H7.45333V6.75332H8.78667V8.73332ZM10.92 2.69332H5.31333V1.97999H10.9133V2.69332H10.92Z"
        fill="#3643BA"
      />
    </svg>
  )
}
